import React from 'react'

import { callifyHtml } from '@utils/helpers'
import linkifyHtml from 'linkifyjs/html'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'

const ParsedText = ({ className, text }) => {
  return (
    <span className={className}>
      {parse(linkifyHtml(callifyHtml(text)))}
    </span>
  )
}

ParsedText.defaultProps = {
  className: '',
  text: ''
}

ParsedText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string
}

export default ParsedText
